/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
/* eslint-disable no-console */

import Configuration from '@/js/Configuration';

export default {
  install(Vue) {
    Vue.prototype.$getCompany = async (companyID, withDivisions, dependence) => {
      let ret = null;
      if (!companyID) {
        return ret;
      }
      try {
        const response = await Vue.axios.get(
          `${Configuration.value('CACCOUNT_ADDRESS')}/api/v1/caccount/company/${companyID}?withDivisions=${withDivisions}&dependence=${dependence}`,
          {
            headers: {
              Authorization: `Bearer ${Vue.cookie.get('accessToken')}`,
            },
          },
        );
        if (response.data.resultCode === '0000') {
          ret = response.data.company;
        }
      } catch (e) {
        console.error(e);
      }
      return ret;
    };

    Vue.prototype.$getDivision = async (divisionID, withUsers, dependence) => {
      let ret = null;
      if (!divisionID) {
        return ret;
      }
      try {
        const response = await Vue.axios.get(
          `${Configuration.value('CACCOUNT_ADDRESS')}/api/v1/caccount/division/${divisionID}?withUsers=${withUsers}&dependence=${dependence}`,
          {
            headers: {
              Authorization: `Bearer ${Vue.cookie.get('accessToken')}`,
            },
          },
        );
        if (response.data.resultCode === '0000') {
          ret = response.data.division;
        }
      } catch (e) {
        console.error(e);
      }
      return ret;
    };

    Vue.prototype.$getUser = async (uID, dependence) => {
      let ret = null;
      if (!uID) {
        return ret;
      }
      try {
        const response = await Vue.axios.get(
          `${Configuration.value('CACCOUNT_ADDRESS')}/api/v1/caccount/user/${uID}?dependence=${dependence}`,
          {
            headers: {
              Authorization: `Bearer ${Vue.cookie.get('accessToken')}`,
            },
          },
        );
        if (response.data.resultCode === '0000') {
          ret = response.data.user;
        }
      } catch (e) {
        console.error(e);
      }
      return ret;
    };

    Vue.prototype.$searchCompany = async (page, limit, keyword) => {
      let ret = null;
      if (!keyword) {
        return ret;
      }
      try {
        const response = await Vue.axios.get(
          `${Configuration.value('CACCOUNT_ADDRESS')}/api/v1/caccount/company/search?page=${page}&limit=${limit}&keyword=${keyword}`,
          {
            headers: {
              Authorization: `Bearer ${Vue.cookie.get('accessToken')}`,
            },
          },
        );
        if (response.data.resultCode === '0000') {
          ret = response.data.companies;
        }
      } catch (e) {
        console.error(e);
      }
      return ret;
    };

    Vue.prototype.$listCompanyUser = async (companyID) => {
      let ret = null;
      if (!companyID) {
        return ret;
      }
      try {
        const response = await Vue.axios.get(
          `${Configuration.value('CACCOUNT_ADDRESS')}/api/v1/caccount/company/${companyID}/user/list`,
          {
            headers: {
              Authorization: `Bearer ${Vue.cookie.get('accessToken')}`,
            },
          },
        );
        if (response.data.resultCode === '0000') {
          ret = response.data.users;
        }
      } catch (e) {
        console.error(e);
      }
      return ret;
    };

    Vue.prototype.$getDevice = async (deviceID, withTrays, dependence) => {
      let ret = null;
      if (!deviceID) {
        return ret;
      }
      try {
        const response = await Vue.axios.get(
          `${Configuration.value('CPRODUCT_ADDRESS')}/api/v1/cproduct/device/${deviceID}?withTrays=${withTrays}&dependence=${dependence}`,
          {
            headers: {
              Authorization: `Bearer ${Vue.cookie.get('accessToken')}`,
            },
          },
        );
        if (response.data.resultCode === '0000') {
          ret = response.data.device;
        }
      } catch (e) {
        console.error(e);
      }
      return ret;
    };

    Vue.prototype.$searchDevice = async (page, limit, companyID, keyword) => {
      let ret = null;
      try {
        const response = await Vue.axios.get(
          `${Configuration.value('CPRODUCT_ADDRESS')}/api/v1/cproduct/device/list?page=${page}&limit=${limit}&companyID=${companyID}&keyword=${keyword}`,
          {
            headers: {
              Authorization: `Bearer ${Vue.cookie.get('accessToken')}`,
            },
          },
        );
        if (response.data.resultCode === '0000') {
          ret = response.data.devices;
        }
      } catch (e) {
        console.error(e);
      }
      return ret;
    };

    Vue.prototype.$getTray = async (trayID, dependence) => {
      let ret = null;
      if (!trayID) {
        return ret;
      }
      try {
        const response = await Vue.axios.get(
          `${Configuration.value('CPRODUCT_ADDRESS')}/api/v1/cproduct/tray/${trayID}?dependence=${dependence}`,
          {
            headers: {
              Authorization: `Bearer ${Vue.cookie.get('accessToken')}`,
            },
          },
        );
        if (response.data.resultCode === '0000') {
          ret = response.data.tray;
        }
      } catch (e) {
        console.error(e);
      }
      return ret;
    };

    Vue.prototype.$getProduct = async (productID, dependence) => {
      let ret = null;
      if (!productID) {
        return ret;
      }
      try {
        const response = await Vue.axios.get(
          `${Configuration.value('CPRODUCT_ADDRESS')}/api/v1/cproduct/product/${productID}?dependence=${dependence}`,
          {
            headers: {
              Authorization: `Bearer ${Vue.cookie.get('accessToken')}`,
            },
          },
        );
        if (response.data.resultCode === '0000') {
          ret = response.data.product;
        }
      } catch (e) {
        console.error(e);
      }
      return ret;
    };

    Vue.prototype.$getPayment = async (paymentID) => {
      let ret = null;
      if (!paymentID) {
        return ret;
      }
      try {
        const response = await Vue.axios.get(
          `${Configuration.value('CPAYMENT_ADDRESS')}/api/v1/cpayment/payment/${paymentID}`,
          {
            headers: {
              Authorization: `Bearer ${Vue.cookie.get('accessToken')}`,
            },
          },
        );
        if (response.data.resultCode === '0000') {
          ret = response.data.payment;
        }
      } catch (e) {
        console.error(e);
      }
      return ret;
    };

    Vue.prototype.$openDevice = async (deviceID) => {
      let ret = null;
      if (!deviceID) {
        return ret;
      }
      try {
        const response = await Vue.axios.put(
          `${Configuration.value('CPAYMENT_ADDRESS')}/api/v1/cpayment/device/${deviceID}/controll/open`,
          null,
          {
            headers: {
              Authorization: `Bearer ${Vue.cookie.get('accessToken')}`,
            },
          },
        );
        ret = response.data;
      } catch (e) {
        console.error(e);
        return e;
      }
      return ret;
    };
  },
};



// WEBPACK FOOTER //
// ./src/js/APIFunction.js